export type ProcessingStatus = 'pending' | 'uploading' | 'uploaded' | 'processing' | 'processed' | 'validated' | 'failed';
export type ValidationStatus = 'pending' | 'valid' | 'invalid' | 'partial_match' | 'order_mismatch';
export type MatchStatus = 'matched' | 'unmatched' | 'partial';

interface StatusStyle {
  color: string;
  bgColor: string;
}

const processingStatusStyles: Record<ProcessingStatus, StatusStyle> = {
  pending: { color: '#3182CE', bgColor: 'rgba(49, 130, 206, 0.08)' },
  uploading: { color: '#3182CE', bgColor: 'rgba(49, 130, 206, 0.08)' },
  uploaded: { color: '#63B3ED', bgColor: 'rgba(99, 179, 237, 0.08)' },
  processing: { color: '#3182CE', bgColor: 'rgba(49, 130, 206, 0.08)' },
  processed: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  validated: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  failed: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
};

const validationStatusStyles: Record<ValidationStatus, StatusStyle> = {
  pending: { color: '#F0AD4E', bgColor: 'rgba(240, 173, 78, 0.08)' },
  valid: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  invalid: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
  partial_match: { color: '#FF9800', bgColor: 'rgba(255, 152, 0, 0.08)' },
  order_mismatch: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.12)' },
};

const matchStatusStyles: Record<MatchStatus, StatusStyle> = {
  matched: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  unmatched: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
  partial: { color: '#FF9800', bgColor: 'rgba(255, 152, 0, 0.08)' },
};

const defaultStyle: StatusStyle = { color: '#C2C2C2', bgColor: 'rgba(194, 194, 194, 0.08)' };

export const getProcessingStatusStyle = (status: string): StatusStyle =>
  processingStatusStyles[status as ProcessingStatus] || defaultStyle;

export const getValidationStatusStyle = (status: string): StatusStyle =>
  validationStatusStyles[status as ValidationStatus] || defaultStyle;

export const getMatchStatusStyle = (status: string): StatusStyle =>
  matchStatusStyles[status as MatchStatus] || defaultStyle;

export const processingStatusLabels: Record<ProcessingStatus, string> = {
  pending: 'Pending',
  uploading: 'Uploading',
  uploaded: 'Uploaded',
  processing: 'Processing',
  processed: 'Processed',
  validated: 'Validated',
  failed: 'Failed',
};

export const validationStatusLabels: Record<ValidationStatus, string> = {
  pending: 'Pending',
  valid: 'Valid',
  invalid: 'Invalid',
  partial_match: 'Partial Match',
  order_mismatch: 'Order Mismatch',
};

export const matchStatusLabels: Record<MatchStatus, string> = {
  matched: 'Matched',
  unmatched: 'Unmatched',
  partial: 'Partial',
};
